import { JsonObject, JsonProperty } from 'json2typescript';

import { AbstractEntity } from '../abstract-entity/abstract-entity';

@JsonObject
export abstract class ArchiveNode extends AbstractEntity {

  @JsonProperty('tenantId', Number)
  tenantId: number = undefined;

  @JsonProperty('parentId', Number)
  parentId: number = undefined;

  @JsonProperty('folder', Boolean)
  folder: boolean = undefined;

  @JsonProperty('idx', Number)
  idx: number = undefined;

}
